"use client";

import type { NameNumerologyCopy } from "./NameNumerology.copy";

interface NameFormProps {
  copy: NameNumerologyCopy;
  name: string;
  onNameChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function NameForm({ copy, name, onNameChange, onSubmit }: NameFormProps) {
  return (
    <>
      <section className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8" aria-label={copy.tilesLabel}>
        {copy.tiles.map(([label, value]) => (
          <div key={label} className="rounded-lg border border-ish-border bg-ish-bg-card p-4">
            <p className="text-body-small font-semibold text-ish-dark">{label}</p>
            <p className="text-caption mt-1 text-ish-muted">{value}</p>
          </div>
        ))}
      </section>

      <form translate="no" onSubmit={onSubmit} className="max-w-md mx-auto">
        <div className="card-sacred p-6 sm:p-8">
          <label
            htmlFor="name-numerology-name"
            className="block text-body-small font-semibold mb-2 text-ish-dark"
          >
            {copy.nameLabel}
          </label>
          <input
            id="name-numerology-name"
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder={copy.namePlaceholder}
            className="w-full px-4 py-3 rounded-lg text-body outline-none border border-ish-border bg-white text-ish-dark focus:border-ish-accent transition-all duration-200"
          />
          <p className="text-caption mt-2 text-ish-faint">{copy.nameHint}</p>
          <button
            type="submit"
            className="btn-sacred w-full mt-4 py-3 rounded-lg text-body font-semibold disabled:opacity-50"
            disabled={name.trim().length === 0}
          >
            {copy.submit}
          </button>
        </div>
      </form>
    </>
  );
}
